<template>
  <div id="app_p" :style="$store.state.equipment.height">
    <van-tabs :color='tabcolor' v-model="active">
      <van-tab title="未完成">
        <div class="tbody"  v-for="(item, index) in orderList" :key="index">
          <div class="conent">
            <div class="conentbox">
              <div class="conentboxrow">
                <div>订单编号：<span>{{item.orderNo}}</span></div>
                <div style="display:flex;align-items:center;">
                  <template v-if="item.payStatus==='unpaid'||item.payStatus==='timeOut'">
                    <template v-if="item.payStatus==='timeOut'">
                      <span style="color:#BDBDBD">订单超时已关闭</span>
                    </template> 
                    <template v-else>
                      <span>剩余时间：</span>
                      <van-count-down :time="duration(item.remainTime)" format="HH:mm:ss" />
                    </template>
                  </template> 
                  <template v-else>
                    <span style="color:orange" v-if="item.payStatus==='payAuditing'">审核中</span>
                    <span style="color:red" v-else>已驳回</span>
                  </template>
                </div>
              </div>
            </div>
            <h4 style="margin: 0 15px 0px 15px; padding-top: 10px">
              {{item.appraisalBatchName}}
            </h4>
            <div class="projectflex">
              <div>工种：{{item.occupation}}</div>
              <div>考试等级：{{item.examRank}}</div>
            </div>
            <div class="projectflex">
              <div>支付人数：{{item.signUpCount}}</div>
              <!-- <div>付款状态：{{item.payStatus==='unpaid'?'未支付':'已支付'}}</div> -->
            </div>
            <div class="contentproject" v-if="item.payStatus==='payAuditing'||item.payStatus==='rejected'">提交时间：{{item.payTime ? $moment(item.payTime).format('YYYY-MM-DD HH:mm:ss') : ''}}</div>
            <div class="contentproject" v-else>创建时间：{{item.orderTime ? $moment(item.orderTime).format('YYYY-MM-DD HH:mm:ss') : ''}}</div>
            <div class="row_footer">
              <div class="price">￥<span style="font-size:18px">{{item.payAmount.toFixed(2)}}</span></div>
              <div class="button">
                <van-button
                  v-if="item.payStatus==='unpaid'"
                  @click="goPay(item.orderId)"
                  type="danger"
                  size="small"
                  style="margin-right:10px"
                >前往支付</van-button>
                <van-button
                  v-if="item.payStatus==='timeOut'"
                  @click="deleteOrder(item.orderId)"
                  type="info"
                  size="small"
                  style="margin-right:10px"
                  plain
                >&nbsp;&nbsp;&nbsp;删除&nbsp;&nbsp;&nbsp;</van-button>
                <van-button
                  v-if="item.payStatus==='rejected'"
                  @click="againPay(item.orderId)"
                  type="info"
                  size="small"
                  style="margin-right:10px"
                  plain
                >重新支付</van-button>
                <van-button
                  v-if="item.payStatus==='timeOut' || item.payStatus==='payAuditing' || item.payStatus==='rejected'"
                  @click="goCheck(item.orderId)"
                  type="info"
                  size="small"
                  style="margin-right:10px"
                >&nbsp;&nbsp;&nbsp;查看&nbsp;&nbsp;&nbsp;</van-button>
              </div>
            </div>
          </div>
        </div>
        <div class="tip" v-if="!orderList.length">
          <img src="@/assets/image/batchSignUp/order_background.png" alt="">
          <span>暂无订单</span>
        </div>
      </van-tab>
      <van-tab title="已完成">
        <div class="tbody" v-for="(item, index) in orderList" :key="index">
          <div class="conent content_is" >
          <div class="conentboxrowis">
            <div>订单编号：{{item.orderNo}}</div>
            </div>
            <h4 style="margin: 0 15px 0px 15px; padding-top: 10px">
              {{item.appraisalBatchName}}
            </h4>
            <div class="projectflex">
              <div>工种：{{item.occupation}}</div>
              <div>考试等级：{{item.examRank}}</div>
            </div>
            <div class="projectflex">
              <div>支付人数：{{item.signUpCount}}人</div>
              <div>付款方式：{{item.payType==="payByBankCard" ? "银行卡转账":"线上支付"}}</div>
            </div>
            <div style="margin: 8px 0 8px 15px" class="deactive"> 付款时间：{{item.payTime ? $moment(item.payTime).format('YYYY-MM-DD HH:mm:ss') : ''}}</div>
            <div class="row_footer">
              <div class="price">
                ￥<span style="font-size:18px">{{item.payAmount.toFixed(2)}}</span>
              </div>
              <div class="button">
                <van-button
                  @click="goCheck(item.orderId)"
                  type="info"
                  size="small"
                  style="margin-right:10px"
                  >&nbsp;&nbsp;&nbsp;查看&nbsp;&nbsp;&nbsp;</van-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="tip" v-if="!orderList.length">
          <img src="@/assets/image/batchSignUp/order_background.png" alt="">
          <span>暂无订单</span>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import headerBox from '@/components/header.vue'
export default {
  name: "orderList",
  components:{
    headerBox,
  },
  data() {
    return {
      tabcolor: '#54B0FB',
      active: 0,
      orderList: []
    }
  },
  watch: {
    active: function() {
      if(this.active === 0){
        this.getOrderList(false)
      }else{
        this.getOrderList(true)
      }
    }
  },
  created: function() {
    this.getOrderList(false)
  },
  methods:{
    getOrderList: function(value) {
      this.orderList = []
      let params = {
        isSuccess: value
      }
      this.$http.get('/registration/order/status', {params}).then(res => {
        if(res.data.success){
          this.orderList = res.data.data
        }
      })
    },
    duration: function(time) {
      return this.$moment.duration(time).asSeconds()*1000
    },
    goPay(orderId){ //前往支付
      this.$router.push(`/order/pay/${orderId}`)
    },
    goCheck(orderId){ //前往查看
      this.$router.push(`/order/detail/${orderId}`)
    }, 
    deleteOrder: function(orderId) {
      this.$dialog.confirm({
        title:'提示',
        confirmButtonText:'确定',
        message:'确定要删除改订单吗？',
        confirmButtonColor:'#54B0FB'
      }).then(()=>{
        let params = {
          id: orderId
        }
        this.$http.put('/registration/order/delete',  params ).then(res=>{
          if(res.data.success){
            this.$message({
              message: "删除成功",
              type: "success",
            })
            this.getOrderList(false)
          }else{
            this.$message({
              message: "删除失败",
              type: "warning",
            })
          }
        }) 
      })
    },
    againPay: function(orderId) { //重新提交订单
      this.$router.push({path:`/order/pay/${orderId}`, query:{payStatus: "bankCardRejected" }})
    }
  }
}
</script>

<style lang='less' scoped>
#app_p {
  background-color: #eee;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 28px;
  width: 100%;
  height: 100vh;
  ::v-deep .van-tabs--line .van-tabs__wrap{
    width: 100%;
    height: @tabheight;
  }
}
.rightcha {
  float: left;
}
.centerwz {
  padding: 0px;
  font-size: 30px;
  line-height: 70px;
}
*{
  box-sizing: border-box;
}
.conent {
  background-color: @whitee;
  .conentboxrowis{
    line-height: @contH;
    display: flex;
    justify-content: flex-start;
    margin-top:6px;
    padding: 0 @paddingpay; 
    border-bottom: @allboxbordermin;
  }
  .row_footer{
    margin: 20px 0 ;
    border-top: 1px solid #BDBDBD;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .price{
      margin-left: 20px;
      color: red;
    }
    .button{
      display: flex;
      align-items: center;
    }
  }
  .projectflex{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:  @paddingorder @paddingpay 0 @paddingpay;  
  }
  .contentproject{
  padding:  @paddingorder 0 0 @paddingpay;  
  }
  .conentbox{
    height: @contH;

  border-bottom: @allboxbordermin;
  // .contentproject{
  //   padding-left: @paddingpay;
  // }
  .conentboxrow{
    height: 100%;
    line-height: @contH;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top:6px;
    padding: 0 @paddingpay;
            
.waitpay{
  color: red;
}
  }
  }

 
}
.deactive{
  color: #797979;
 
}
.content_is{
    height: 430px!important;
  }

#top {

  text-align: center;
 height: @headerh;
   box-sizing: border-box;
  padding-top: @headerpt;
  background-color:@backgroundcolor;
  padding-bottom: @headerpb;
}

.tip{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 30px;
  margin-top: 300px;
  img{
    width: 400px;
  }
  span{
    color: #969799;
  }
}
::v-deep .van-count-down{
  color: red;
}
</style>